module.exports = __webpack_public_path__ + "static/media/bravo.b280c361.jpg";